module.exports = __webpack_public_path__ + "img/weekly-board-crown-gold.cb54e1c5.svg";